
import { baseApi } from "./baseApi";

const VEHICLE_MAINTENANCE_BASE_URL = "/vehicle-maintenances";
export const vehicleMaintenanceApi = baseApi.injectEndpoints({
  tagTypes: ["VehicleMaintenance"],

  endpoints: (builder) => ({
    addVehicleMaintenance: builder.mutation({
      query: (payLoad) => ({
        url: VEHICLE_MAINTENANCE_BASE_URL,
        method: "POST",
        body: payLoad
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "VehicleMaintenance", id: _id },
        { type: "VehicleMaintenance", id: "LIST" },
      ],
    }),

    listVehicleMaintenance: builder.query({
      query: (params) => ({
        url: VEHICLE_MAINTENANCE_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "VehicleMaintenance", _id })),
            { type: "VehicleMaintenance", id: "LIST" },
          ]
          : [{ type: "VehicleMaintenance", id: "LIST" }],
    }),

    getDDLVehicleMaintenanceList: builder.query({
      query: (params) => ({ url: `${VEHICLE_MAINTENANCE_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
          result?.data
              ? [
                  ...result?.data?.map(({ _id }) => ({ type: "VehicleMaintenance", _id })),
                  { type: "VehicleMaintenance", id: "DDL" },
              ]
              : [{ type: "VehicleMaintenance", id: "DDL" }],
  }),
    
    getVehicleMaintenanceDetail: builder.query({
      query: (maintenanceId) => `${VEHICLE_MAINTENANCE_BASE_URL}/${maintenanceId}`,
      providesTags: (_result, _error, { _id }) => [
        { type: "VehicleMaintenance", _id },
        { type: "VehicleMaintenance", id: "LIST" },
      ],
    }),

    updateVehicleMaintenance: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${VEHICLE_MAINTENANCE_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id: id }) => [
        { type: "VehicleMaintenance", id },
        { type: "VehicleMaintenance", id: "LIST" },
      ],
    }),
    listVehicleMaintenanceByVehicleId: builder.query({
      query: ({ vehicleId, ...params }) => ({
        url: `${VEHICLE_MAINTENANCE_BASE_URL}/vehicle/${vehicleId}`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "VehicleMaintenance", id: _id })),
              { type: "VehicleMaintenance", id: "LIST" },
            ]
          : [{ type: "VehicleMaintenance", id: "LIST" }],
    }),
  }),

});

export const {
  useAddVehicleMaintenanceMutation,
  useListVehicleMaintenanceQuery,
  useGetDDLVehicleMaintenanceListQuery,
  useLazyListVehicleMaintenanceQuery,
  useGetVehicleMaintenanceQuery,
  useGetVehicleMaintenanceDetailQuery,
  useUpdateVehicleMaintenanceMutation,

  useListVehicleMaintenanceByVehicleIdQuery,
  
} = vehicleMaintenanceApi;